"use strict";
exports.__esModule = true;
exports.PlatformProducerContractBuilder = exports.PlatformProducerContract = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var PlatformProducerContract = /** @class */ (function () {
    function PlatformProducerContract() {
    }
    PlatformProducerContract.isActive = function (contract) {
        var nowInMillis = core_common_logic_1.CommonLogic.nowToDateTime()
            .plus({ day: 1 })
            .toMillis();
        return contract.startsAt.toMillis() <= nowInMillis && nowInMillis <= contract.endsAt.toMillis();
    };
    return PlatformProducerContract;
}());
exports.PlatformProducerContract = PlatformProducerContract;
var PlatformProducerContractBuilder = /** @class */ (function () {
    function PlatformProducerContractBuilder(contract) {
        this.contract = contract;
    }
    PlatformProducerContractBuilder.initiateWithContract = function (newContract) {
        return new PlatformProducerContractBuilder(newContract);
    };
    PlatformProducerContractBuilder.initiate = function (producerPartyId, producerDeliveryUnitId, deliveryUnitSaleCatalogId) {
        return new PlatformProducerContractBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            producerPartyId: producerPartyId,
            producerDeliveryUnitId: producerDeliveryUnitId,
            deliveryUnitSaleCatalogId: deliveryUnitSaleCatalogId,
            startsAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            endsAt: core_common_logic_1.CommonLogic.nowToDateTime().plus({ years: 5 }),
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    PlatformProducerContractBuilder.prototype.getId = function () {
        return this.contract.id;
    };
    PlatformProducerContractBuilder.prototype.withId = function (id) {
        this.contract.id = id;
        return this;
    };
    PlatformProducerContractBuilder.prototype.resetStartDateToNow = function () {
        return this.resetStartToReferenceStartDate(core_common_logic_1.CommonLogic.nowToDateTime());
    };
    PlatformProducerContractBuilder.prototype.resetEndDateToNow = function () {
        this.contract.endsAt = core_common_logic_1.CommonLogic.nowToDateTime();
        this.contract.updatedAt = core_common_logic_1.CommonLogic.nowToDateTime();
        return this;
    };
    PlatformProducerContractBuilder.prototype.resetStartToReferenceStartDate = function (referenceStartDate) {
        this.contract.startsAt = referenceStartDate;
        this.contract.endsAt = referenceStartDate.plus({ years: 5 });
        (this.contract.createdAt = core_common_logic_1.CommonLogic.nowToDateTime()),
            (this.contract.updatedAt = core_common_logic_1.CommonLogic.nowToDateTime());
        return this;
    };
    PlatformProducerContractBuilder.prototype.build = function () {
        return this.contract;
    };
    PlatformProducerContractBuilder.prototype.buildUpdate = function () {
        return {
            producerPartyId: this.contract.producerPartyId,
            producerDeliveryUnitId: this.contract.producerDeliveryUnitId,
            deliveryUnitSaleCatalogId: this.contract.deliveryUnitSaleCatalogId,
            startsAt: this.contract.startsAt,
            endsAt: this.contract.endsAt
        };
    };
    return PlatformProducerContractBuilder;
}());
exports.PlatformProducerContractBuilder = PlatformProducerContractBuilder;
